// Add custom code below this line
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

if (!customElements.get("hc-product-group")) {
  class HCProductGroup extends HTMLElement {
    constructor() {
      super();
      this.inputID = document.querySelector('input[name="id"]');
      this.ProductGroupMaster = this;
      this.activeItems = this.querySelectorAll(".selected");
      if (this.inputID) {
        this.inputID.addEventListener(
          "change",
          this.onChangeVariantId.bind(this)
        );
      }

      this.init();
    }

    init() {
      const currentVariant = window.currentVariant;
      this.updateVariant(currentVariant);
    }

    onChangeVariantId(e) {
      const variantID = e.target.value;
      const currentVariant = window.globalProduct.variants.find(
        (v) => v.id == variantID
      );

      if (!currentVariant) return;
      this.updateVariant(currentVariant);

      this.dispatchEvent(
        new CustomEvent("hcChangeVariantId", {
          detail: {
            currentVariant,
          },
        })
      );
    }

    updateVariant(currentVariant) {
      this.activeItems.forEach((element) => {
        const itemPrice = element.querySelector(".product__price");
        const formattedPrice = Shopify.formatMoney(
          currentVariant.price,
          window.theme.moneyFormat
        );

        if (itemPrice) itemPrice.textContent = formattedPrice;
        const savingPrice = element.querySelector(".saving-price");
        if (savingPrice) {
          const productPrice = currentVariant.price * 1;
          const productComparePrice = currentVariant.compare_at_price * 1;
          const customsProductPrice = savingPrice.querySelectorAll(
            ".custom-product-price"
          );

          customsProductPrice.forEach(function (customProductPrice) {
            if (customProductPrice) {
              if (customProductPrice.classList.contains("custom-price")) {
                customProductPrice.textContent = Shopify.formatMoney(
                  productPrice,
                  window.theme.moneyFormat
                );
              }

              if (
                customProductPrice.classList.contains("custom-compare-price")
              ) {
                if (productComparePrice != 0) {
                  customProductPrice.textContent = Shopify.formatMoney(
                    productComparePrice,
                    window.theme.moneyFormat
                  );
                } else {
                  customProductPrice.textContent = Shopify.formatMoney(
                    productPrice,
                    window.theme.moneyFormat
                  );
                }
              }

              if (
                customProductPrice.classList.contains("custom-saving-price")
              ) {
                let savingPrice = 0;
                if (
                  productComparePrice != 0 &&
                  productPrice < productComparePrice
                ) {
                  savingPrice = productComparePrice - productPrice;
                }
                customProductPrice.textContent = Shopify.formatMoney(
                  savingPrice,
                  window.theme.moneyFormat
                );
              }

              if (customProductPrice.classList.contains("custom-saving-percent")) {
                let savingPercent = "0%";
                if (
                  productComparePrice != 0 &&
                  productPrice < productComparePrice
                ) {
                  savingPercent = `${Math.round(
                    ((productComparePrice - productPrice) * 100) /
                      productComparePrice
                  )}%`;
                }
                customProductPrice.textContent = savingPercent;
              }
            }
          });
        }
      });
    }
  }

  customElements.define("hc-product-group", HCProductGroup);

  if (!customElements.get("hc-variant-radios")) {
    customElements.define(
      "hc-variant-radios",
      class VariantRadios extends HTMLElement {
        constructor() {
          super();
          this.radioInputs = document.querySelectorAll(
            ".radio__buttons .radio__button input"
          );
          this.radioInputs.forEach((element) => {
            element.addEventListener(
              "change",
              this.onChangeVariantInput.bind(this)
            );
          });

          this.init();

          document.addEventListener("shopify:section:load", function (event) {
            const currentVariant = window.currentVariant;
            setTimeout(() => {
              this.updateVariantElement(currentVariant);
            }, 500);
          });
        }

        init() {
          const currentVariant = window.currentVariant;

          this.updateVariantElement(currentVariant);
        }

        onChangeVariantInput(e) {
          const variantID =
            document.querySelector('input[name="id"]')?.value || "";
          const currentVariant = window.globalProduct.variants.find(
            (v) => v.id == variantID
          );
          if (currentVariant) this.updateVariantElement(currentVariant);
        }

        updateVariantElement(currentVariant) {
          const optionOther1 = currentVariant.option1;
          const optionOther2 = currentVariant.option2;
          const optionOther3 = currentVariant.option3;
          const productData = window.globalProduct;
          const selectorWrapper =
            document.querySelectorAll(".selector-wrapper");
          for (let index = 0; index < selectorWrapper.length; index++) {
            const wrapper = selectorWrapper[index];
            const position = wrapper?.getAttribute("data-option-position") || 0;
            const buttons = wrapper.querySelectorAll(".radio__button") || [];
            for (let index = 0; index < buttons.length; index++) {
              const button = buttons[index];
              const input = button.querySelector("input");
              const value = input?.value || "";
              const priceEle = button.querySelector(".variant-price__value");
              const matchedVariant = productData.variants.find((variant) => {
                if (position == "1") {
                  return (
                    variant.option1 == value &&
                    variant.option2 == optionOther2 &&
                    variant.option3 == optionOther3
                  );
                } else if (position == "2") {
                  return (
                    variant.option1 == optionOther1 &&
                    variant.option2 == value &&
                    variant.option3 == optionOther3
                  );
                } else if (position == "3") {
                  return (
                    variant.option1 == optionOther1 &&
                    variant.option2 == optionOther2 &&
                    variant.option3 == value
                  );
                }
                return false;
              });

              if (matchedVariant) {
                const formattedPrice = Shopify.formatMoney(
                  matchedVariant.price,
                  window.theme.moneyFormat
                );
                if (matchedVariant.available) {
                  button.classList.remove("disabled");
                } else {
                  button.classList.add("disabled");
                }
                if (priceEle) priceEle.textContent = formattedPrice;
              }
            }
          }
        }
      }
    );
  }

  if (!customElements.get("hc-carousel")) {
    customElements.define(
      "hc-carousel",
      class ProductGroupCarousel extends HTMLElement {
        constructor() {
          super();
          this.track = this.querySelector(".carousel-track");
          this.prevBtn = this.querySelector(".carousel-button.prev");
          this.nextBtn = this.querySelector(".carousel-button.next");
          this.items = this.querySelectorAll(".carousel-item");
          this.itemWidth = (this.items?.[0]?.clientWidth || 0) + 10;
          this.activeItem = this.querySelector(".selected .carousel-item");
    
          // Touch/drag variables
          this.touchStartX = 0;
          this.touchStartY = 0;
          this.touchEndX = 0;
          this.touchEndY = 0;
          this.isDragging = false;
          this.dragStartX = 0;
          this.currentTranslate = 0;
          this.prevTranslate = 0;
          this.animationID = 0;
          this.velocity = 0;
          this.lastTime = 0;
          this.lastPosition = 0;
          this.isHorizontalSwipe = false;
    
          this.init();
    
          this.prevBtn?.addEventListener("click", this.onClickPrev.bind(this));
          this.nextBtn?.addEventListener("click", this.onClickNext.bind(this));
    
          // Touch events
          this.track.addEventListener(
            "touchstart",
            this.handleTouchStart.bind(this),
            { passive: true }
          );
          this.track.addEventListener(
            "touchmove",
            this.handleTouchMove.bind(this),
            { passive: false }
          );
          this.track.addEventListener(
            "touchend",
            this.handleTouchEnd.bind(this)
          );
    
          // Mouse events
          this.track.addEventListener(
            "mousedown",
            this.handleMouseDown.bind(this)
          );
          window.addEventListener("mousemove", this.handleMouseMove.bind(this));
          window.addEventListener("mouseup", this.handleMouseUp.bind(this));
    
          // Disable drag image
          this.track.addEventListener("dragstart", (e) => e.preventDefault());
        }
    
        init() {
          this.visibleCount = Math.floor(this.offsetWidth / this.itemWidth);
          this.currentIndex = 0;
          if (this.activeItem) {
            const currentPosistion = Array.from(this.items).indexOf(
              this.activeItem
            );
            if (currentPosistion * 1 > this.visibleCount) {
              this.currentIndex = currentPosistion * 1 - 1;
            }
          }
    
          this.updateCarousel(false);
        }
    
        updateCarousel(withAnimation = true) {
          const offset = this.currentIndex * this.itemWidth;
          this.prevTranslate = this.currentTranslate;
          this.currentTranslate = -offset;
    
          if (withAnimation) {
            this.track.style.transition =
              "transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)";
            this.track.style.transform = `translateX(${this.currentTranslate}px)`;
          } else {
            this.track.style.transition = "none";
            this.track.style.transform = `translateX(${this.currentTranslate}px)`;
          }
    
          // Update buttons visibility
          this.prevBtn.style.display =
            this.currentIndex === 0 ? "none" : "flex";
          this.nextBtn.style.display =
            this.currentIndex >= this.items.length - this.visibleCount
              ? "none"
              : "flex";
        }
    
        onClickNext(e) {
          e.preventDefault();
          if (this.currentIndex < this.items.length - this.visibleCount) {
            this.currentIndex++;
            this.updateCarousel();
          }
        }
    
        onClickPrev(e) {
          e.preventDefault();
          if (this.currentIndex > 0) {
            this.currentIndex--;
            this.updateCarousel();
          }
        }
    
        getPositionX(event) {
          return event.type.includes("mouse")
            ? event.clientX
            : event.touches[0].clientX;
        }
    
        getPositionY(event) {
          return event.type.includes("mouse")
            ? event.clientY
            : event.touches[0].clientY;
        }
    
        handleTouchStart(e) {
          this.touchStartX = this.getPositionX(e);
          this.touchStartY = this.getPositionY(e);
          this.isDragging = true;
          this.isHorizontalSwipe = false;
          this.dragStartX = this.touchStartX;
          this.lastPosition = this.currentTranslate;
          this.lastTime = performance.now();
          this.velocity = 0;
    
          cancelAnimationFrame(this.animationID);
          this.track.style.transition = "none";
        }
    
        handleTouchMove(e) {
          if (!this.isDragging) return;
          
          const currentX = this.getPositionX(e);
          const currentY = this.getPositionY(e);
          
          // Check if it's a horizontal swipe
          if (!this.isHorizontalSwipe) {
            const diffX = Math.abs(currentX - this.touchStartX);
            const diffY = Math.abs(currentY - this.touchStartY);
            
            // If vertical movement is greater than horizontal, ignore the swipe
            if (diffY > diffX) {
              this.isDragging = false;
              return;
            }
            this.isHorizontalSwipe = true;
          }
          
          e.preventDefault();
    
          const diff = currentX - this.touchStartX;
          this.touchStartX = currentX;
    
          // Calculate velocity for inertia effect
          const currentTime = performance.now();
          const timeDiff = currentTime - this.lastTime;
          if (timeDiff > 0) {
            this.velocity =
              (this.currentTranslate - this.lastPosition) / timeDiff;
            this.lastPosition = this.currentTranslate;
            this.lastTime = currentTime;
          }
    
          this.currentTranslate += diff;
    
          // Apply boundaries
          const maxTranslate = 0;
          const minTranslate = -(this.items.length - 1) * this.itemWidth;
          this.currentTranslate = Math.min(
            Math.max(this.currentTranslate, minTranslate),
            maxTranslate
          );
    
          this.track.style.transform = `translateX(${this.currentTranslate}px)`;
        }
    
        handleTouchEnd() {
          if (!this.isDragging || !this.isHorizontalSwipe) return;
          this.isDragging = false;
    
          // Apply inertia
          const momentum = this.velocity * 100;
          let targetTranslate = this.currentTranslate + momentum;
    
          // Snap to nearest slide
          const slideWidth = this.itemWidth;
          const snapIndex = Math.round(-targetTranslate / slideWidth);
          this.currentIndex = Math.max(
            0,
            Math.min(snapIndex, this.items.length - this.visibleCount)
          );
    
          this.updateCarousel();
        }
    
        handleMouseDown(e) {
          e.preventDefault();
          this.isDragging = true;
          this.dragStartX = this.getPositionX(e);
          this.lastPosition = this.currentTranslate;
          this.lastTime = performance.now();
          this.velocity = 0;
    
          cancelAnimationFrame(this.animationID);
          this.track.style.transition = "none";
          this.track.style.cursor = "grabbing";
        }
    
        handleMouseMove(e) {
          if (!this.isDragging) return;
    
          const currentX = this.getPositionX(e);
          const diff = currentX - this.dragStartX;
          this.dragStartX = currentX;
    
          // Calculate velocity
          const currentTime = performance.now();
          const timeDiff = currentTime - this.lastTime;
          if (timeDiff > 0) {
            this.velocity =
              (this.currentTranslate - this.lastPosition) / timeDiff;
            this.lastPosition = this.currentTranslate;
            this.lastTime = currentTime;
          }
    
          this.currentTranslate += diff;
    
          // Apply boundaries
          const maxTranslate = 0;
          const minTranslate = -(this.items.length - 1) * this.itemWidth;
          this.currentTranslate = Math.min(
            Math.max(this.currentTranslate, minTranslate),
            maxTranslate
          );
    
          this.track.style.transform = `translateX(${this.currentTranslate}px)`;
        }
    
        handleMouseUp() {
          if (!this.isDragging) return;
          this.isDragging = false;
          this.track.style.cursor = "grab";
    
          // Apply inertia
          const momentum = this.velocity * 150; // Slightly more momentum for mouse
          let targetTranslate = this.currentTranslate + momentum;
    
          // Snap to nearest slide
          const slideWidth = this.itemWidth;
          const snapIndex = Math.round(-targetTranslate / slideWidth);
          this.currentIndex = Math.max(
            0,
            Math.min(snapIndex, this.items.length - this.visibleCount)
          );
    
          this.updateCarousel();
        }
      }
    );
  }

  if (!customElements.get("hc-collapsible")) {
    customElements.define(
      "hc-collapsible",
      class ProductGroupCollapsible extends HTMLElement {
        constructor() {
          super();
          this.collapsible = this.querySelector(".collapsible");

          if (this.collapsible) {
            this.content = this.collapsible.nextElementSibling;
            this.innerContent = this.content.querySelector(".content__inner");
            this.collapsible.addEventListener(
              "click",
              this.onClickTitle.bind(this)
            );
          }
        }

        onClickTitle(e) {
          this.collapsible = this.querySelector(".collapsible");
          const button = this.collapsible;
          const isExpanded = button.getAttribute("aria-expanded") === "true";
          button.setAttribute("aria-expanded", !isExpanded);

          if (!isExpanded) {
            const innerHeight =
              this.innerContent.getBoundingClientRect().height;
            this.content.style.height = `${innerHeight}px`;

            const onTransitionEnd = () => {
              this.content.removeEventListener(
                "transitionend",
                onTransitionEnd
              );
              this.content.style.overflow = "visible";
            };
            this.content.addEventListener("transitionend", onTransitionEnd);
          } else {
            this.content.style.overflow = "hidden";
            this.content.style.height = "0px";
          }
        }
      }
    );
  }

  if (!customElements.get("hc-show-more-items")) {
    customElements.define(
      "hc-show-more-items",
      class ShowMoreItems extends HTMLElement {
        constructor() {
          super();
          const self = this;
          this.moreItemButton = this.querySelector(".more-items-btn");
          this.activeItem = this.querySelector(".selected");
          this.items = this.querySelectorAll(".product-group__item");

          if (this.items.length > 5) {
            this.items.forEach(function (item, index) {
              if (index > 3) {
                item.classList.add("product-hidden");
              }
            });
          }

          if (this.moreItemButton) {
            this.moreItemButton.addEventListener(
              "click",
              this.onClickShowMoreItems.bind(this)
            );
          }

          if (this.activeItem) {
            this.classList.add("expanded");
          }
        }

        onClickShowMoreItems(e) {
          e.preventDefault();
          e.stopPropagation();
          this.classList.toggle("expanded");
        }
      }
    );
  }
}

// <hc-collapsible class="collapsible-group group-type__collapsible group-type__container">
//         <button class="collapsible" aria-expanded="true">
//           <span class="collapsible__title">
//             <div class="product-group-title">
//               {{ group.title }}
//               {% if current_product and group.show_option_name == true -%}
//                 <span class="option-name"> - {{ current_product.title }}</span>
//               {%- endif %}
//             </div>
//           </span>
//           <svg class="collapsible__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//             <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
//           </svg>
//         </button>
//         <div class="content" aria-hidden="true">
//           <div class="content__inner">
//             {% for item in group.products.value %}
//               {% assign product_in_group = item.product.value %}
//               {% if product_in_group.handle == product.handle %}
//                 <a href="{{ product_in_group.url }}">
//                   <div class="carousel-item {% if product_in_group.available == false %}disabled{% endif %} {% if product_in_group.handle == product.handle %}selected{% endif %}">
//                     {% if item.media.value %}
//                       <img
//                         src="{{ item.media.value | img_url: 'large' }}"
//                         alt="{{ item.media.value.alt | escape }}"
//                         loading="lazy"
//                         width="200"
//                         height="200"
//                       >
//                     {% else %}
//                       <img
//                         src="{{ product_in_group.featured_image | img_url: 'large' }}"
//                         alt="{{ product_in_group.featured_image.alt | escape }}"
//                         loading="lazy"
//                         width="200"
//                         height="200"
//                       >
//                     {% endif %}

//                     <div class="carousel-item__content">
//                       <div class="carousel-item__title">
//                         {{ item.title }}
//                       </div>
//                       <div class="carousel-item__price">
//                         {{ product_in_group.price | money }}
//                       </div>
//                     </div>
//                   </div>
//                 </a>
//               {% endif %}
//             {% endfor %}

//             {% for item in group.products.value %}
//               {% assign product_in_group = item.product.value %}
//               {% if product_in_group.handle != product.handle %}
//                 <a href="{{ product_in_group.url }}">
//                   <div class="carousel-item {% if product_in_group.available == false %}disabled{% endif %} {% if product_in_group.handle == product.handle %}selected{% endif %}">
//                     {% if item.media.value %}
//                       <img
//                         src="{{ item.media.value | img_url: 'large' }}"
//                         alt="{{ item.media.value.alt | escape }}"
//                         loading="lazy"
//                         width="200"
//                         height="200"
//                       >
//                     {% else %}
//                       <img
//                         src="{{ product_in_group.featured_image | img_url: 'large' }}"
//                         alt="{{ product_in_group.featured_image.alt | escape }}"
//                         loading="lazy"
//                         width="200"
//                         height="200"
//                       >
//                     {% endif %}

//                     <div class="carousel-item__content">
//                       <div class="carousel-item__title">
//                         {{ item.title }}
//                       </div>
//                       <div class="carousel-item__price">
//                         {{ product_in_group.price | money }}
//                       </div>
//                     </div>
//                   </div>
//                 </a>
//               {% endif %}
//             {% endfor %}
//           </div>
//         </div>
//       </hc-collapsible>
